<template>
  <div id="datatable-component">
    <v-data-table
      :show-select="tableOption.showSelect !== undefined ? tableOption.showSelect : true"
      v-model="selectedIds"
      :headers="tableOption.headers"
      :items="tableData"
      :item-key="'id'"
      :loading="loading"
      :class="'elevation-1'"
      :mobile-breakpoint="0"
      :items-per-page="defaultItemsPerPage"
      :options.sync="dataTableOptions"
      :server-items-length="totalTableDataCount"
      :footer-props="footerProps"
      @click:row="view"
    >
      <template v-slot:[`item.action`]="{ item }">
        <!-- Edit Icon -->
        <v-icon @click="editTableData(item)" v-if="!removeEditBtn">mdi-pencil-circle-outline</v-icon>
        <!-- Hide delete icon when user role is admin -->
        <v-icon @click.stop="singleDeleteTableData(item)" v-if="!removeDeleteBtn" :class="{ 'd-none': tableOption.moduleName === 'userRole' && item.is_default}">mdi-delete-circle</v-icon>
        <!-- Show delete icon user has right and project status is open -->
        <v-icon @click.stop="singleDeleteTableData(item)" v-if="removeDeleteBtn && tableOption.moduleName === 'project' && $checkRight(['delete_project']) && item.status == 'open'">mdi-delete-circle</v-icon>
        <!-- Hide delete icon when user is logged in and user is admin -->
        <v-icon @click.stop="singleDeleteTableData(item)" v-if="removeDeleteBtn && tableOption.moduleName === 'user'" :class="{ 'd-none':(item.is_default === 1 || item.id === $getUserData().id)}">mdi-delete-circle</v-icon>
        <!-- Hide Edit and Delete button when prefix is set to is_default -->
        <v-icon @click="editTableData(item)" v-if="tableOption.moduleName === 'prefix'" :class="{ 'd-none': item.is_default}">mdi-pencil-circle-outline</v-icon>
        <v-icon @click.stop="singleDeleteTableData(item)" v-if="tableOption.moduleName === 'prefix'" :class="{ 'd-none': item.is_default}">mdi-delete-circle</v-icon>
        <!-- Copy Icon -->
        <v-icon @click.stop="makeDuplicate(item)" v-if="['project', 'machine', 'machineMaintenance', 'welder', 'user', 'userRole', 'weldingProcedure'].includes(tableOption.moduleName)">mdi-book-check-outline</v-icon>
      </template>

      <!-- Welder logout -->
      <template v-if="tableOption.moduleName === 'welder'" v-slot:[`item.logoutAction`]="{ item }">
        <v-chip small :color="(item.is_login === 0 ? 'orange': 'green')" class="white--text" @click.stop="logOutWelder(item)">{{ item.is_login === 0 ? "Logged out" : "Logout"}}</v-chip>
      </template>

      <template v-slot:[`item.${i}`]="{ item }" v-for="(slt, i) in tableItemSlot">
        <v-chip small :color="slt[item[i]]['color']" class="white--text" :key="i">{{ slt[item[i]]['text'] }}</v-chip>
      </template>
      <template v-slot:[`item.${idx}`]="{ item }" v-for="(sl, idx) in filterColumn">
        <span :key="idx">{{ item[idx] | formatDate }}</span>
      </template>
    </v-data-table>
    <v-dialog v-model="deleteConfirmationModal" width="600">
      <v-card>
        <v-card-title class="headline">Are you sure?</v-card-title>
        <v-card-text v-if="tableOption.moduleName !== 'project'">Are you sure you want delete these {{tableOption.moduleName}}? </v-card-text>
        <v-card-text v-if="tableOption.moduleName === 'project'">Are you sure you want delete these project ? The record you are trying to delete might be used in other data. We suggest you to make it inactive instead of delete.
        Do you still want to delete the record which will delete all related records</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="deactivateTableData(deleteIds)">Yes</v-btn>
          <v-btn color="primary" text @click="deleteConfirmationModal = false; deleteIds = ''">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="notSelectedModal" width="600">
      <v-card>
        <v-card-title class="headline">Not selected any {{tableOption.moduleName}}</v-card-title>
        <v-card-text>You have not selected any {{tableOption.moduleName}} to inactivate! Please select atleast one {{tableOption.moduleName}} to inactivate.</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="notSelectedModal = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const WithoutWatchers = {
  methods: {
    $withoutWatchers (cb) {
      const watchers = this._watchers.map((watcher) => ({ cb: watcher.cb, sync: watcher.sync }))

      for (const index in this._watchers) {
        this._watchers[index] = Object.assign(this._watchers[index], { cb: () => null, sync: true })
      }

      cb()

      for (const index in this._watchers) {
        this._watchers[index] = Object.assign(this._watchers[index], watchers[index])
      }
    }
  }
}
export default {
  mixins: [WithoutWatchers],
  props: {
    tableOption: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tableItemSlot: {
      type: Object,
      default: function () {
        return {}
      }
    },
    editFunction: {
      type: Function
    },
    viewFunction: {
      type: Function
    },
    deleteFunction: {
      type: Function
    },
    requestCallBack: {
      type: Function
    },
    filterColumn: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    dataTableOptions: {
      handler (value) {
        this.getTableData()
      },
      deep: true,
    },
  },
  created () {
    this.$eventBus.$on('$refreshDataTable', () => {
      const options = {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: this.defaultItemsPerPage,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [],
      }
      this.dataTableOptions = options
      this.selectedIds = []
      this.dataTableFilter = {}
    })
    this.$eventBus.$on('$filterDataTable', (filter) => {
      this.dataTableFilter = filter
      if (this.dataTableOptions.page !== 1) {
        this.$withoutWatchers(() => {
          this.dataTableOptions.page = 1
        })
      } else {
        this.getTableData()
      }
    })
  },
  computed: {
    removeDeleteBtn () {
      const action = this.tableOption.headers.filter((x) => x.value === 'action')
      return action.length > 0 ? !!action[0].removeDeleteBtn : true
    },
    removeEditBtn () {
      const action = this.tableOption.headers.filter((x) => x.value === 'action')
      return action.length > 0 ? !!action[0].removeEditBtn : true
    }
  },
  data () {
    return {
      loading: true,
      selectedIds: [],
      dataTableOptions: {},
      tableData: [],
      totalTableDataCount: 0,
      footerProps: { 'items-per-page-options': [10, 20, 50, 100, 200] },
      defaultItemsPerPage: 10,
      deleteConfirmationModal: false,
      notSelectedModal: false,
      dataTableFilter: {},
    }
  },
  beforeDestroy () {
    // this.$eventBus.$off('$refreshDataTable')
    // this.$eventBus.$off('$filterDataTable')
  },
  methods: {
    getTableData () {
      this.loading = true
      this.$axios.post(this.tableOption.url, { dataTableConfig: this.dataTableOptions, dataTableFilter: this.dataTableFilter }, { mainLoader: false }).then((res) => {
        this.loading = false
        this.tableData = res.data.data
        this.totalTableDataCount = res.data.total_count
        this.$emit('requestCallBack', res.data.data, res.data.total) // for load data in report
        if (this.tableData.length >= this.defaultItemsPerPage) {
          document.getElementsByClassName('v-data-table__wrapper')[0].classList.add('add-bottom-margin')
          document.getElementsByClassName('v-data-footer')[0].classList.add('fixed-datatable-footer')
        } else {
          document.getElementsByClassName('v-data-table__wrapper')[0].classList.remove('add-bottom-margin')
          document.getElementsByClassName('v-data-footer')[0].classList.remove('fixed-datatable-footer')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    view (item, other) {
      if (['project', 'machine', 'welder', 'prefix', 'user'].includes(this.tableOption.moduleName)) {
        this.$router.push({ path: `${this.tableOption.moduleName}/view/${item.id}`, })
      } else {
        if (this.tableOption.moduleName === 'weldingProcedure') {
          if (item.type === 'wps_aws') {
            this.$router.push({ path: `weldingProcedure/wpsAws/view/${item.id}`, })
          } else if (item.type === 'pqr_asme') {
            this.$router.push({ path: `weldingProcedure/pqrAsme/view/${item.id}`, })
          } else if (item.type === 'pqr_aws') {
            this.$router.push({ path: `weldingProcedure/pqrAws/view/${item.id}`, })
          } else if (item.type === 'wps_asme') {
            this.$router.push({ path: `weldingProcedure/wpsAsme/view/${item.id}`, })
          }
        }
      }
    },
    editTableData (item) {
      if (this.tableOption.editUrl !== undefined) {
        this.$router.push({ path: `${this.tableOption.editUrl}/${item.id}`, })
      } else if (this.tableOption.moduleName === 'weldingProcedure') {
        if (item.type === 'wps_aws') {
          this.$router.push({ path: `weldingProcedure/wpsAws/edit/${item.id}`, })
        } else if (item.type === 'pqr_asme') {
          this.$router.push({ path: `weldingProcedure/pqrAsme/edit/${item.id}`, })
        } else if (item.type === 'pqr_aws') {
          this.$router.push({ path: `weldingProcedure/pqrAws/edit/${item.id}`, })
        } else if (item.type === 'wps_asme') {
          this.$router.push({ path: `weldingProcedure/wpsAsme/edit/${item.id}`, })
        }
      } else {
        this.$emit('editFunction', item.id)
      }
    },
    viewTableData (item) {
      if (this.tableOption.viewUrl !== undefined) {
        this.$router.push({ path: `${this.tableOption.viewUrl}/${item.id}`, })
      } else {
        this.$emit('viewFunction', item.id)
      }
    },
    singleDeleteTableData (item) {
      this.deleteIds = ''
      this.deleteIds = item.id
      this.deleteConfirmationModal = true
    },
    massDeleteTableData () {
      if (this.selectedIds.length !== 0) {
        this.deleteIds = []
        this.deleteIds = this.selectedIds
        this.deleteConfirmationModal = true
      } else {
        this.notSelectedModal = true
      }
    },
    deactivateTableData (data) {
      this.deleteConfirmationModal = false
      this.$axios.post(this.tableOption.deleteRoute, { selectedIds: data }).then((res) => {
        this.getTableData()
        this.deleteIds = ''
        this.selectedIds = []
      }).catch((err) => {
        this.$eventBus.$emit('$globalSnackbar', 'red', err.response.data.error_description)
      })
    },
    makeDuplicate (data) {
      if (['project', 'machine', 'machineMaintenance', 'welder', 'user', 'userRole'].includes(this.tableOption.moduleName)) {
        localStorage.setItem('clone_data', JSON.stringify({ module: this.tableOption.moduleName, module_id: data.id }))
        this.$router.push({ path: this.tableOption.moduleName + '/create' })
      } else if (this.tableOption.moduleName === 'weldingProcedure') {
        localStorage.setItem('clone_data', JSON.stringify({ module: data.type, module_id: data.id }))
        if (data.type === 'wps_aws') {
          this.$router.push({ path: 'weldingProcedure/wpsAws/create' })
        } else if (data.type === 'pqr_asme') {
          this.$router.push({ path: 'weldingProcedure/pqrAsme/create' })
        } else if (data.type === 'pqr_aws') {
          this.$router.push({ path: 'weldingProcedure/pqrAws/create' })
        } else if (data.type === 'wps_asme') {
          this.$router.push({ path: 'weldingProcedure/wpsAsme/create' })
        }
      }
    },
    logOutWelder (data) {
      if (data.is_login) {
        this.$eventBus.$emit('$logOutWelderEvent', { CompanyID: data.company_id, WelderPasscode: data.passcode })
      }
    }
  },
}
</script>
<style lang="scss">
#datatable-component {
  .v-data-table__wrapper.add-bottom-margin {
    margin-bottom: 52px;
  }
  .v-data-table__wrapper tbody tr:hover {
    cursor: pointer
  }
  .v-data-footer.fixed-datatable-footer {
    position: fixed;
    top: auto;
    bottom: 0px;
    background: #FFF;
    left: 0px;
    right: 0px;
  }
  .v-data-table tbody > tr > td:nth-child(2) {
    width: 110px;
  }
}
</style>
